import type { IconProps } from './base';
import { BaseIcon } from './base';

export function IconAttributeTraveller(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M4 8C4.55228 8 5 7.55229 5 7V5H7C7.55228 5 8 4.55228 8 4C8 3.44772 7.55228 3 7 3H4C3.44772 3 3 3.44772 3 4V7C3 7.55229 3.44772 8 4 8Z"
        fill="currentColor"
      />
      <path
        d="M4 16C3.44772 16 3 16.4477 3 17V20C3 20.5523 3.44772 21 4 21H7C7.55229 21 8 20.5523 8 20C8 19.4477 7.55229 19 7 19H5V17C5 16.4477 4.55228 16 4 16Z"
        fill="currentColor"
      />
      <path
        d="M17 5C16.4477 5 16 4.55228 16 4C16 3.44772 16.4477 3 17 3H20C20.5523 3 21 3.44772 21 4V7C21 7.55228 20.5523 8 20 8C19.4477 8 19 7.55228 19 7V5H17Z"
        fill="currentColor"
      />
      <path
        d="M20 16C19.4477 16 19 16.4477 19 17V19H17C16.4477 19 16 19.4477 16 20C16 20.5523 16.4477 21 17 21H20C20.5523 21 21 20.5523 21 20V17C21 16.4477 20.5523 16 20 16Z"
        fill="currentColor"
      />
      <path
        d="M9 8C9 6.35 10.35 5 12 5C13.65 5 15 6.35 15 8C15 9.65 13.65 11 12 11C10.35 11 9 9.65 9 8Z"
        fill="currentColor"
      />
      <path
        d="M7 17V15.47C7 12.96 9.97 11.89 12 11.89C14.03 11.89 17 12.97 17 15.47V17H14.5L12.7682 19.0781C12.3684 19.5579 11.6316 19.5579 11.2318 19.0781L9.5 17H7Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
